import React, { Component } from 'react'
import { Label, Row } from "reactstrap";
import { observer } from "mobx-react";
import ModalForm from "../../../comum/components/ModalForm";
import CabotagemCadastrarStore from "../stores/CabotagemCadastrarStore";
import FormSelectSimples from "../../../comum/components/FormSelectSimples";
import FormInputSimples from "../../../comum/components/FormInputSimples";
import FormOnlyPositiveNumberSimples from "../../../comum/components/FormNumberSimples";
import { isInvalidoCodigoContainer } from "../../../../utils/validadores";
import { inject } from "mobx-react";
import {isInvalidoChaveCTe} from '../../../../utils/validadores'

@inject("store")
@observer
export class CabotagemCadastrar extends Component {
    constructor(props) {
        super(props);

        this.controller = new CabotagemCadastrarStore(this.props.editando ? this.props.editando : false);
        this.controllerCabotagem = this.props.controller;
        this.validacaoStore = this.props.store.validacaoStore;

        this.state = {
            salvado: false
        }
    };

    componentDidMount() {
        if (this.props.editando) {
            this.controller.navioSelecionado = this.controllerCabotagem.naviosFiltros.filter(n => n.value === this.props.editando.Navio)[0];
            this.controller.regimeSelecionado = this.controllerCabotagem.regimes.filter(n => n.value === this.props.editando.Regime)[0];

        }
    };

    handleSalvar = () => {
        this.setState({ salvado: true }, () => {
            if (this.validar())
                if (isInvalidoCodigoContainer(this.controller.novaCabotagem.Cntr)) {
                } else {
                    this.controller.novaCabotagem.Navio = (this.controller.navioSelecionado) ? this.controller.navioSelecionado.value : null;
                    this.controllerCabotagem.incluirCabotagem(this.controller.novaCabotagem);
                }
        });
    };

    validar = () => {
        const emails = this.controller.novaCabotagem.Email.split(",")
        emails.map(email => {
            if (email.length > 0 && !this.validacaoStore.isEmail(email)) {
                this.controller.msgEmail = this.validacaoStore.getMensagemErro("isEmail");
            } else if (this.controller.novaCabotagem.Email.length > 1000) {
                this.controller.msgEmail = "Limite de 1000 caracteres";
            } else this.controller.msgEmail = false;
        })
        return this.controller.navioSelecionado
            && !this.alertaCte()
            && !this.alertaChave()
            && !this.alertaRegime()
            && !this.alertaRegime()
            && !this.controller.msgEmail;
    }

    alertaRegime = () => {
        return !this.controller.novaCabotagem.Regime && this.state.salvado ? "Campo obrigatório" : false;
    };

    alertaChave = () => {
        if (this.controller.novaCabotagem.Chave.length > 0 && this.controller.novaCabotagem.Chave.length < 44) return "Insira 44 caracteres";
        if (isInvalidoChaveCTe(this.controller.novaCabotagem.Chave) !== false) return isInvalidoChaveCTe(this.controller.novaCabotagem.Chave);
        return this.controller.novaCabotagem.Chave.length === 0 && this.state.salvado ? "Campo obrigatório" : false;
    };

    alertaCte = () => {
        if (this.controller.novaCabotagem.Cte.length > 200) return "Limite de 200 caracteres"
        return this.controller.novaCabotagem.Cte.length === 0 && this.state.salvado ? "Campo obrigatório" : false;
    };

    form = () => {

        return <ModalForm salvando={this.controller.salvando} esconderSalvar={false} className="tamanho-modal-cabotagem area-form-modal"
            onClickCancelar={() => this.controllerCabotagem.cancelarInclusao()}
            onClickSalvar={() => this.handleSalvar()} >
            <h2>Nova liberação</h2>
            <Row>
                <FormSelectSimples titulo="Navio *" xs={12} sm={12} md={6} lg={6} xl={6}
                    itens={this.controllerCabotagem.naviosFiltros}
                    dado={this.controller.navioSelecionado}
                    alerta={!this.controller.navioSelecionado && this.state.salvado ? "Campo obrigatório" : false}
                    bloqueado={!this.controllerCabotagem.naviosFiltros}
                    onChange={(event) => this.controller.setNavio(event)} />
                <FormInputSimples titulo="CTe *" xs={12} sm={12} md={6} lg={6} xl={6}
                    dado={this.controller.novaCabotagem.Cte}
                    alerta={this.alertaCte()}
                    onChange={(event) => { this.controller.novaCabotagem.Cte = event.target.value.replace(/\s/g, '').toUpperCase() }} />
                <FormOnlyPositiveNumberSimples titulo="Chave CTe *" xs={12} sm={12} md={12} lg={12} xl={12}
                    dado={this.controller.novaCabotagem.Chave}
                    limiteMaximo={44}
                    alerta={this.alertaChave()}
                    validador={isInvalidoChaveCTe}
                    onChange={(event) => { this.controller.novaCabotagem.Chave = event.target.value.replace(/\s/g, '').toUpperCase() }} />
                <FormInputSimples
                    titulo="Container *"
                    xs={12}
                    sm={12}
                    md={6}
                    lg={6}
                    xl={6}
                    dado={this.controller.novaCabotagem.Cntr}
                    alerta={
                        (this.state.salvado && this.controller.novaCabotagem.Cntr.length === 0)
                            || (this.controller.novaCabotagem.Cntr.length > 0 && isInvalidoCodigoContainer(this.controller.novaCabotagem.Cntr))
                            ? "Formato: HHHH1234567"
                            : false
                    }
                    onChange={(event) => {
                        const value = event.target.value.toUpperCase().replace(/\s+/g, ''); // Remove todos os espaços em branco
                        this.controller.novaCabotagem.Cntr = value;
                        // Atualize o estado ou o componente, se necessário
                    }}
                />

                <FormSelectSimples titulo="Regime *" xs={12} sm={12} md={6} lg={6} xl={6}
                    itens={this.controllerCabotagem.regimes}
                    dado={this.controller.regimeSelecionado}
                    alerta={this.alertaRegime()}
                    onChange={(event) => { this.controller.escolherRegime(event) }} />
                <FormInputSimples titulo="Email para envio do booking" xs={12} sm={12} md={12} lg={12} xl={12}
                    dado={this.controller.novaCabotagem.Email}
                    alerta={this.controller.msgEmail && this.state.salvado ? this.controller.msgEmail : false}
                    onChange={(event) => { this.controller.novaCabotagem.Email = event.target.value.toUpperCase() }}
                    extraInfo="Utilizar vírgula para inclusão de mais de um e-mail" />
            </Row>
        </ModalForm>
    };

    // handleFecharModais = () => {
    //     this.controller.salvando = false;
    //     if (this.controllerCabotagem.Sucesso)
    //         this.controllerCabotagem.inserindo = false;
    // };

    render() {
        return (
            <React.Fragment>
                {this.form()}
            </React.Fragment>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/liberacoes/cabotagem/components/CabotagemCadastrar.js